import getApiSettingsHelper from 'Helper/getApiSettings';

/**
 * interface fot fetching a send message instance
 */
export interface SendMessageConfig {
    /**
     * userId
     */
    userId: string;
    /**
     * alias
     */
    alias: string;
    /**
     * secureKey
     */
    secureKey: string;
    /**
     * message
     */
    message: string;
    /**
     * messageType
     */
    messageType: string;
}

/**
 * sendMessage
 */
export const getApiSettings = (config: SendMessageConfig) => {
    const params = new URLSearchParams();
    params.append('userId', config.userId);
    params.append('alias', config.alias);
    params.append('secureKey', config.secureKey);
    params.append('message', config.message);
    params.append('messageType', config.messageType);

    return getApiSettingsHelper(params);
};
